import React from "react";
import Cta from "../../Shared/Cta";
import { Link } from "react-router-dom";
import CustomInput from "../../Shared/CustomInput";
import { useForm } from "react-hook-form";
import Notification from "../../Shared/Notification";
import SubmitForm from "../../Shared/SubmitForm";
const Notice = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => {
    console.log("submitting data ", data);
  };
  return (
    <>
      <div class="breadcrumbs-area">
        <h3>Notice Board</h3>
        <ul>
          <li>
            <Link to="/admin">Home</Link>
          </li>
          <li>Notice</li>
        </ul>
      </div>
      <div class="row">
        <div class="col-4-xxxl col-12">
          <div class="card height-auto">
            <div class="card-body">
              <div class="heading-layout1">
                <div class="item-title">
                  <h3>Create A Notice</h3>
                </div>
                <Cta />
              </div>
              <form class="new-added-form" onSubmit={handleSubmit(onSubmit)}>
                <div class="row">
                  <div class="col-12-xxxl col-lg-6 col-12 form-group">
                    <CustomInput
                      label={"Title"}
                      register={register}
                      errors={errors}
                      name={"title"}
                    />
                  </div>
                  <div class="col-12-xxxl col-lg-6 col-12 form-group">
                    <CustomInput
                      label={"Details"}
                      register={register}
                      errors={errors}
                      name={"details"}
                    />
                  </div>
                  <div class="col-12-xxxl col-lg-6 col-12 form-group">
                    <CustomInput
                      label={"Posted By"}
                      register={register}
                      errors={errors}
                      name={"posted"}
                    />
                    <i class="fas fa-user"></i>
                  </div>
                  <div class="col-12-xxxl col-lg-6 col-12 form-group">
                    <CustomInput
                      label={"Date"}
                      register={register}
                      errors={errors}
                      name={"date"}
                    />

                    <i class="far fa-calendar-alt"></i>
                  </div>
                  <SubmitForm />
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* <Notification /> */}
        <div class="col-8-xxxl col-12">
          <div class="card height-auto">
            <div class="card-body">
              <div class="heading-layout1">
                <div class="item-title">
                  <h3>Notice Board</h3>
                </div>
                <Cta />
              </div>
              <form class="mg-b-20">
                <div class="row gutters-8">
                  <div class="col-lg-5 col-12 form-group">
                    <input
                      type="text"
                      placeholder="Search by Date ..."
                      class="form-control"
                    />
                  </div>
                  <div class="col-lg-5 col-12 form-group">
                    <input
                      type="text"
                      placeholder="Search by Title ..."
                      class="form-control"
                    />
                  </div>
                  <div class="col-lg-2 col-12 form-group">
                    <button
                      type="submit"
                      class="fw-btn-fill btn-gradient-yellow"
                    >
                      SEARCH
                    </button>
                  </div>
                </div>
              </form>
              <div class="notice-board-wrap">
                <div class="notice-list">
                  <div class="post-date bg-skyblue">16 June, 2019</div>
                  <h6 class="notice-title">
                    <a href="#">
                      Great School Great School manag mene esom text of the
                      printing Great School manag mene esom text of the printing
                      manag mene esom text of the printing.
                    </a>
                  </h6>
                  <div class="entry-meta">
                    Jennyfar Lopez / <span>5 min ago</span>
                  </div>
                </div>
                <div class="notice-list">
                  <div class="post-date bg-yellow">16 June, 2019</div>
                  <h6 class="notice-title">
                    <a href="#">
                      Great School Great School manag mene esom text of the
                      printing Great School manag mene esom text of the printing
                      manag mene esom text of the printing.
                    </a>
                  </h6>
                  <div class="entry-meta">
                    Jennyfar Lopez / <span>5 min ago</span>
                  </div>
                </div>
                <div class="notice-list">
                  <div class="post-date bg-pink">16 June, 2019</div>
                  <h6 class="notice-title">
                    <a href="#">
                      Great School Great School manag mene esom text of the
                      printing Great School manag mene esom text of the printing
                      manag mene esom text of the printing.
                    </a>
                  </h6>
                  <div class="entry-meta">
                    Jennyfar Lopez / <span>5 min ago</span>
                  </div>
                </div>
                <div class="notice-list">
                  <div class="post-date bg-skyblue">16 June, 2019</div>
                  <h6 class="notice-title">
                    <a href="#">
                      Great School Great School manag mene esom text of the
                      printing Great School manag mene esom text of the printing
                      manag mene esom text of the printing.
                    </a>
                  </h6>
                  <div class="entry-meta">
                    Jennyfar Lopez / <span>5 min ago</span>
                  </div>
                </div>
                <div class="notice-list">
                  <div class="post-date bg-yellow">16 June, 2019</div>
                  <h6 class="notice-title">
                    <a href="#">
                      Great School Great School manag mene esom text of the
                      printing Great School manag mene esom text of the printing
                      manag mene esom text of the printing.
                    </a>
                  </h6>
                  <div class="entry-meta">
                    Jennyfar Lopez / <span>5 min ago</span>
                  </div>
                </div>
                <div class="notice-list">
                  <div class="post-date bg-pink">16 June, 2019</div>
                  <h6 class="notice-title">
                    <a href="#">
                      Great School Great School manag mene esom text of the
                      printing Great School manag mene esom text of the printing
                      manag mene esom text of the printing.
                    </a>
                  </h6>
                  <div class="entry-meta">
                    Jennyfar Lopez / <span>5 min ago</span>
                  </div>
                </div>
                <div class="notice-list">
                  <div class="post-date bg-skyblue">16 June, 2019</div>
                  <h6 class="notice-title">
                    <a href="#">
                      Great School Great School manag mene esom text of the
                      printing Great School manag mene esom text of the printing
                      manag mene esom text of the printing.
                    </a>
                  </h6>
                  <div class="entry-meta">
                    Jennyfar Lopez / <span>5 min ago</span>
                  </div>
                </div>
                <div class="notice-list">
                  <div class="post-date bg-yellow">16 June, 2019</div>
                  <h6 class="notice-title">
                    <a href="#">
                      Great School Great School manag mene esom text of the
                      printing Great School manag mene esom text of the printing
                      manag mene esom text of the printing.
                    </a>
                  </h6>
                  <div class="entry-meta">
                    Jennyfar Lopez / <span>5 min ago</span>
                  </div>
                </div>
                <div class="notice-list">
                  <div class="post-date bg-pink">16 June, 2019</div>
                  <h6 class="notice-title">
                    <a href="#">
                      Great School Great School manag mene esom text of the
                      printing Great School manag mene esom text of the printing
                      manag mene esom text of the printing.
                    </a>
                  </h6>
                  <div class="entry-meta">
                    Jennyfar Lopez / <span>5 min ago</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Notice;
